module.exports = __webpack_public_path__ + "img/DataTable.09fcf6c1.svg";